import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import CheckBox from '../../Components/CheckBox/CheckBox'
import { FaPlusSquare } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { MdDeleteOutline, MdOutlineSaveAlt } from 'react-icons/md'
import http from '../../Service/http'
import { toast } from 'react-toastify'
import { accept, OknoRoleTeacherType } from '../../store/accept'
import SearchRole from '../../block/ReactSearchRole'
import { getOknoTeacherRole } from '../../Service/accept'
import ConfirmModal from './../../Components/Modal/ConfirmModal'
import { FcCancel } from 'react-icons/fc'
import { auth } from '../../store/auth'

export const AcceptCustomer = observer(function () {
	const { t } = useTranslation()
	const notify = (title: string) => toast.success(title)
	const [idTeacher, setIdTeacher] = useState<number>(0)
	const [addNew, setAddNew] = useState<boolean>(false)
	const [form, setForm] = useState<OknoRoleTeacherType>({
		id_AVN_User: auth.user.data.id,
		id_okno_role_teacher: 1,
		t_fio: '',
		t_fio_pole1: false,
		t_fio_pole2: false,
		t_fio_pole3: false,
		t_fio_pole4: false,
		t_fio_pole5: false,
		t_fio_pole6: false,
		t_fio_pole7: false,
		t_fio_pole8: false,
		t_fio_pole9: false
	})

	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
		name: string
	}>({
		modal: false,
		id_docs: 0,
		name: ''
	})

	const [disbles, setDsbles] = useState<number>(0)

	const getAllTeachers = async () => {
		const data = await getOknoTeacherRole()
		accept.newOknoTeachers(data)
	}

	useEffect(() => {
		getAllTeachers()
	}, [])

	const tdCenter = { display: 'flex', justifyContent: 'center', width: '100%' }

	return (
		<>
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0,
						name: ''
					})
				}}
				title={delModal.name}
				isOpen={delModal.modal}
				hundleTrue={async () => {
					if (delModal.id_docs) {
						const res = await http.delete('/okno/customer?id=' + delModal.id_docs)
						if (res.data.result) {
							getAllTeachers()
							notify(t('st:other.saved'))
							setDelModal({
								modal: false,
								id_docs: 0,
								name: ''
							})
						} else {
							notify(t('st:other.reject'))
						}
					}
				}}
			/>
			<div className='TableWrapper'>
				<table className='accept_table'>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%', textAlign: 'left' }}>{t('st:table.fio')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.bib')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.materialAcc')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.settlmentAcc')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.hostel')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.hr')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.kafedra')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.depAXP')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.accountand')}</th>

							<th style={{ width: '5%' }}>
								<FaPlusSquare
									style={{ fontSize: 18 }}
									onClick={() => {
										setAddNew(!addNew)
										setDsbles(0)
									}}
								/>
							</th>
						</tr>
					</thead>
					<tbody>
						{addNew ? (
							<tr style={{ backgroundColor: 'rgb(160 202 223)', height: '52' }}>
								<td>{0}</td>
								<td style={{ textAlign: 'left' }}>
									<SearchRole
										style={{ borderRadius: '6px' }}
										changeIdStud={(param: number) => {
											setIdTeacher(param)
										}}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole1: e }
											})
										}}
										checked={form.t_fio_pole1}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole2: e }
											})
										}}
										checked={form.t_fio_pole2}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole3: e }
											})
										}}
										checked={form.t_fio_pole3}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole4: e }
											})
										}}
										checked={form.t_fio_pole4}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole5: e }
											})
										}}
										checked={form.t_fio_pole5}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole6: e }
											})
										}}
										checked={form.t_fio_pole6}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole7: e }
											})
										}}
										checked={form.t_fio_pole7}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<CheckBox
										styles={tdCenter}
										onchange={(e: any) => {
											setForm((state: any) => {
												return { ...state, t_fio_pole8: e }
											})
										}}
										checked={form.t_fio_pole8}
										active={true}
										dsbl={false}
										item={form}
									/>
								</td>
								<td>
									<div className='edit'>
										{
											<MdOutlineSaveAlt
												title={t('st:button.save')}
												onClick={async () => {
													const res = await http.post('/okno/customer', {
														...form,
														id_okno_role_teacher: idTeacher
													})
													if (res.data.result) {
														getAllTeachers()
														notify(t('st:other.saved'))
														setAddNew(!addNew)
														setDsbles(0)
													} else {
														notify(t('st:other.reject'))
													}
												}}
											/>
										}
									</div>
								</td>
							</tr>
						) : (
							''
						)}

						{accept.oknoRoleTeacher.map((item: any, index: number) => {
							let dsbl = true
							if (disbles == item.id_okno_role_teacher) {
								return (
									<tr key={index} style={{ backgroundColor: 'rgb(160 202 223)', height: dsbl ? '' : '52' }}>
										<td>{index + 1}</td>
										<td style={{ textAlign: 'left' }}>{item.t_fio}</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole1: e }
													})
												}}
												checked={form.t_fio_pole1}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole2: e }
													})
												}}
												checked={form.t_fio_pole2}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole3: e }
													})
												}}
												checked={form.t_fio_pole3}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole4: e }
													})
												}}
												checked={form.t_fio_pole4}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole5: e }
													})
												}}
												checked={form.t_fio_pole5}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole6: e }
													})
												}}
												checked={form.t_fio_pole6}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole7: e }
													})
												}}
												checked={form.t_fio_pole7}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<CheckBox
												styles={tdCenter}
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, t_fio_pole8: e }
													})
												}}
												checked={form.t_fio_pole8}
												active={true}
												dsbl={false}
												item={form}
											/>
										</td>
										<td>
											<div className='edit'>
												{
													<MdOutlineSaveAlt
														title='Сохранить'
														onClick={async () => {
															const res = await http.put('/okno/customer', form)
															if (res.data.result) {
																getAllTeachers()
																notify(t('st:other.saved'))
															} else {
																notify(t('st:other.reject'))
															}
															setDsbles(0)
														}}
													/>
												}
												<FcCancel
													onClick={() => {
														setDsbles(0)
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr
									key={index}
									style={{ backgroundColor: dsbl ? '' : 'rgb(160 202 223)', height: dsbl ? '' : '52' }}
									onClick={() => {
										setDsbles(0)
										setAddNew(false)
									}}
								>
									<td>{index + 1}</td>
									<td style={{ textAlign: 'left' }}>{item.t_fio}</td>

									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole1}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole2}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole3}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole4}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole5}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole6}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole7}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<CheckBox
											onchange={() => {}}
											styles={tdCenter}
											checked={item.t_fio_pole8}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<div className='edit'>
											{
												<FiEdit
													onClick={(e: any) => {
														e.stopPropagation()
														setDsbles(item.id_okno_role_teacher)
														setForm(item)
														setAddNew(false)
													}}
												/>
											}
											<MdDeleteOutline
												style={{ zIndex: 1222 }}
												onClick={() => {
													setDelModal({
														modal: true,
														id_docs: item.id_okno_role_teacher,
														name: item.t_fio
													})
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
						{/* {
                makeCheckboxes().map(item => {
                    return <td>
                        {
                            item
                        }
                    </td>
                })
            } */}
					</tbody>
				</table>
			</div>
		</>
	)
})
